import { Link } from "@inertiajs/react"
import type { ReactNode } from "react"

const HASHTAG_REGEX = /#([a-záéíóúñü\w]+)/gi

interface HashtagTextProps {
  text: string
}

export default function HashtagText({ text }: HashtagTextProps) {
  const parts: ReactNode[] = []
  let lastIndex = 0

  for (const match of text.matchAll(HASHTAG_REGEX)) {
    const tag = match[1]
    const startIndex = match.index

    if (startIndex > lastIndex) {
      parts.push(text.slice(lastIndex, startIndex))
    }

    parts.push(
      <Link
        key={`${tag}-${startIndex}`}
        href={`/buscar?hashtag=${encodeURIComponent(tag.toLowerCase())}`}
        className="text-krown-300 hover:text-krown-200 font-medium hover:underline"
      >
        #{tag}
      </Link>,
    )

    lastIndex = startIndex + match[0].length
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  if (parts.length === 0) {
    return <>{text}</>
  }

  return <>{parts}</>
}
